import {
	LIGHT_CARMINE_PINK,
	ORANGE_WEB,
} from "@/controls/shared/constants/colors";
import { FormControlLabel, Grid2 as Grid, Switch } from "@mui/material";

interface StatusBarReferenceProps {
	coloringEnabled: boolean;
	onToggleColoring: (enabled: boolean) => void;
}

const StatusIndicator = ({
	color,
	label,
}: { color: string; label: string }) => (
	<Grid size="auto" container spacing={0.5} alignItems="center" wrap="nowrap">
		<Grid size="auto" display="flex" alignItems="center">
			<div
				style={{
					width: 15,
					height: 15,
					backgroundColor: color,
					border: "1px solid rgba(0,0,0,0.2)",
				}}
			/>
		</Grid>
		<Grid size="auto">
			<span style={{ whiteSpace: "nowrap" }}>{label}</span>
		</Grid>
	</Grid>
);

export const StatusBarReference = (props: StatusBarReferenceProps) => {
	const { coloringEnabled, onToggleColoring } = props;

	return (
		<Grid
			container
			alignItems="center"
			spacing={2}
			wrap="nowrap"
			sx={{ p: 1, justifyContent: "space-between" }}
		>
			<Grid size="auto" container spacing={2} alignItems="center" wrap="nowrap">
				<StatusIndicator color={ORANGE_WEB} label="Below minimum limit" />
				<StatusIndicator
					color={LIGHT_CARMINE_PINK}
					label="Above maximum limit"
				/>
			</Grid>
			<Grid size="auto">
				<FormControlLabel
					control={
						<Switch
							checked={coloringEnabled}
							onChange={(e) => onToggleColoring(e.target.checked)}
							color="primary"
							size="small"
						/>
					}
					label={<span style={{ fontSize: "inherit" }}>Enable Coloring</span>}
					labelPlacement="start"
					style={{ marginRight: 0 }}
				/>
			</Grid>
		</Grid>
	);
};
